import type { Period } from '../../api/types';

const index = ({ year, month }: Period) => year * 12 + month - 1;

function parseMonth(key: string): Period {
  const [year, month] = key.split('-').map(Number) as [number, number];
  return { year, month };
}

/** Radar has data from its first month to the current one. */
export function radarCovers(period: Period, firstMonth: string, today: Date): boolean {
  const current = { year: today.getFullYear(), month: today.getMonth() + 1 };
  return index(period) >= index(parseMonth(firstMonth)) && index(period) <= index(current);
}

/** Months before the current one are closed: bringing them from Radar replaces their figures. */
export function isClosedMonth(period: Period, today: Date): boolean {
  return index(period) < index({ year: today.getFullYear(), month: today.getMonth() + 1 });
}

/** "hoy a las 14:30", "ayer a las 20:00" or "el 20/10 a las 14:30". */
export function describeWhen(iso: string, now: Date): string {
  const date = new Date(iso);
  const time = date.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
  const day = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  const days = Math.round((day(now) - day(date)) / 86_400_000);
  if (days === 0) return `hoy a las ${time}`;
  if (days === 1) return `ayer a las ${time}`;
  return `el ${date.toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit' })} a las ${time}`;
}

/** "14:30 y 20:00" */
export function listTimes(times: string[]): string {
  return times.length > 1 ? `${times.slice(0, -1).join(', ')} y ${times.at(-1)}` : (times[0] ?? '');
}

const ERRORS: Record<string, string> = {
  RADAR_UNAUTHORIZED: 'Radar ha rechazado la clave de acceso (RADAR_API_KEY). Hay que pedir una nueva al equipo de Radar.',
  RADAR_UNAVAILABLE: 'Radar no responde ahora mismo. Se reintentará solo; también puedes probar más tarde.',
  RADAR_UNREACHABLE: 'Radar no responde ahora mismo. Se reintentará solo; también puedes probar más tarde.',
  RADAR_REJECTED: 'Radar no ha aceptado la petición.',
  RADAR_BAD_RESPONSE: 'Radar ha devuelto una respuesta que no se entiende.',
  INTERRUPTED: 'La aplicación se reinició durante la actualización.',
};

export function describeSyncError(code: string | null): string {
  return (code && ERRORS[code]) ?? 'No se ha podido actualizar desde Radar.';
}
